import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/core/services/auth.service';
import { GenericToasterService } from 'src/app/core/services/generic-toaster.service';
import { HomePageService } from '../services/home-page.service';

@Component({
  selector: 'app-dialog-fake-door-button-mail',
  templateUrl: './dialog-fake-door-button-mail.component.html',
  styleUrls: ['./dialog-fake-door-button-mail.component.scss']
})
export class DialogFakeDoorButtonMailComponent implements OnInit {

  formEmail: UntypedFormGroup = this.fb.group({
    email: new UntypedFormControl('', [Validators.required]),
    nombreApellido: new UntypedFormControl('', [Validators.required])
  });

  title: string = '';
  text: string = '';
  imgSrc: string = '';
  imgName: string = '';
  imgWidth:string='';

  private user = this.authService.userdata;

  constructor(
    public dialogRef: MatDialogRef<DialogFakeDoorButtonMailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private genericToasterService: GenericToasterService,
    private homePageService:HomePageService
  ) { }

  ngOnInit(): void {
    this.formEmail.controls['nombreApellido'].setValue(this.user.Nombre + ' ' + this.user.Apellido);
    this.formEmail.controls['email'].setValue(this.user.NombreUsuario);
    this.formEmail.controls['email'].disable();

    this.title = this.data.title;
    this.text = this.data.text;
    this.imgSrc = "assets/images/FakeDoorButtonImg/" + this.data.imgName;
    this.imgName = this.data.imgName;
    this.imgWidth = this.data.imgWidth;
  }

  Contactar() {
    const formEmail = this.formEmail.getRawValue();
    const parametros = {
      email: formEmail.email,
      NombreYApellido: formEmail.nombreApellido,
      funcionalidad: this.data.funcionalidad

    };
       return new Promise<void>((resolve)=>{
          this.homePageService.EnviarSolicitudContcto(parametros).subscribe({
            next: (result:any) => {
              if(result.isFailed){
              this.genericToasterService.pushError("ERROR_APLICACION");
              }
              else{
                this.genericToasterService.pushSuccess("FAKE_DOOR_BUTTON.DATOS_ENVIADOS_CORRECTAMENTE");
                this.dialogRef.close();
              }
              resolve();
            },
            error: (err) => {      
              this.genericToasterService.pushError("ERROR_APLICACION");
            }
          });
        });
  }

}
